import { createSelector } from 'reselect';
import { connect } from 'react-redux';

/* actions */
import { changeSaveDashboardPromptVisibility } from '@store/dashboards/ui/actions';
import * as createActions from '@store/dashboards/create/actions';
import * as updateActions from '@store/dashboards/update/actions';

/* selectors */
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { selectors as dashboardsUIStoreSelector } from '@store/dashboards/ui';
import * as createSelectors from '@store/dashboards/create/selectors';
import * as updateSelectors from '@store/dashboards/update/selectors';

import DashboardPrompt from './DashboardPrompt';

const selector = createSelector(
  tabsStoreSelector,
  dashboardsUIStoreSelector,
  createSelectors.createLoaderSelector,
  updateSelectors.updateLoaderSelector,
  createSelectors.payloadSelector,
  updateSelectors.payloadSelector,
  createSelectors.errorCodeSelector,
  updateSelectors.errorCodeSelector,
  (
    tabsStore,
    dashboardsUIStore,
    createLoader,
    updateLoader,
    createPayload,
    updatePayload,
    createErrorCode,
    updateErrorCode,
  ) => ({
    isLoading: (!!createPayload || !!updatePayload) && (createLoader || updateLoader),
    hasError: createErrorCode !== 0 || updateErrorCode !== 0,
    tabsStore,
    dashboardsUIStore,
  }),
);

export default connect(
  selector,
  {
    createDashboard: createActions.createDashboard,
    updateDashboard: updateActions.updateDashboard,
    initCreating: createActions.initRequest,
    initUpdating: updateActions.initRequest,
    changeSaveDashboardPromptVisibility,
  },
)(DashboardPrompt);
